<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="moveParentRouter()">arrow_back</a> -->
                            <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">arrow_back</a> -->
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="goBackPreviousPage">arrow_back</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('120')}}
                                <!-- 과제 -->
                            </div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" :style="unClipping" aria-label="bookmark" alt="bookmark" @click="bookMark">bookmark</a>
                        </section>
                    </div>


                    <div class="tab_bar w-full">
                        <div class="mdc-tab-bar top-tab-bar" role="tablist" id="missionViewTab">
                            <div class="mdc-tab-scroller">
                                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                                    <div class="mdc-tab-scroller__scroll-content">
                                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="setTab('basic')">
                                            <span class="mdc-tab__content">
                                                <span class="mdc-tab__text-label">
                                                    {{$t('121')}}
                                                    <!-- 과제물 -->
                                                </span>
                                            </span>
                                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                            </span>
                                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                                        </button>
                                        <button class="mdc-tab" role="tab" tabindex="1" @click="setTab('feedback')">
                                            <span class="mdc-tab__content">
                                                <span class="mdc-tab__text-label">
                                                    {{$t('122')}}
                                                    <!-- 피드백 -->
                                                </span>
                                            </span>
                                            <span class="mdc-tab-indicator">
                                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                            </span>
                                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                                        </button>

                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <section class="flex-grow-1 h-full overflow-hidden">
                    <view-information
                        v-if="missionData && tabType === 'basic'"
                        :name="missionData.name"
                        :description="missionData.description"
                        :reference="missionData.reference"
                        :answer="missionData.answer"
                        :eval="missionData.eval"
                        :learnEndDate= "missionData.learnEndDate"
                        :status= "missionData.status"

                    ></view-information>

                    <view-feedback
                        v-if="tabType === 'feedback'"
                    ></view-feedback>
                </section>
                <router-view></router-view>

                
                
            </div>
        </div>
        
        
    </div>
    
</template>

<script>
/**
 * 나의 학습 상세 - 미션 상세 메인 컴포넌트(my learning view - mission view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import Information from './Information.vue'
import Feedback from './Feedback.vue'
import { topAppBarMixin } from '@/mixins/topAppBar.js'

import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    data() {
        return {
            missionData: null,
            tabBar: null,
            tabType: 'basic',
            unClipping:{'color':'gray !important'},
            clippingBookMark: false,
            clippingCount: 0
        }
    },

    components: {
        'view-information': Information,
        'view-feedback': Feedback,
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.fatchData()
        this.tabBar = new MDCTabBar(document.querySelector('#missionViewTab'))
    },

    methods: {
        // 미션 상세 정보 API 호출(get mission view data)
        fatchData() {
            let params = {
                learnId: this.$route.params.learnId,
                assignmentId: this.$route.params.assignmentId
            }

            learnApi.learnViewMissionView(params).then((response) => {
                console.log('learnViewMissionView', response.data.data)
                this.missionData = response.data.data
                if(this.missionData.clipping ==  true) {
                    this.clippingBookMark =  true
                    this.unClipping = {'color':''}
                }
            })
        },

        setTab(type) {
            this.tabType = type
        },
        bookMark(){
            let params = {
                learnId: this.$route.params.learnId,
                assignmentId: this.$route.params.assignmentId
            }
            if(this.clippingBookMark === false) {
                learnApi.learnMissionClippingPost(params).then((response) => {
                    console.log('learnMissionClippingPost', response.data.data)
                    if(response.data.data===true){
                        this.clippingBookMark =  true
                        this.unClipping = {'color':''}
                    } else {
                        this.unClipping = {'color':'gray !important'}
                    }
                }).catch((err) => {
                    
                })
            }
            if(this.clippingBookMark === true) {    
                learnApi.learnMissionClippingDelete(params).then((response) => {
                    if(response.data.data===true){
                        this.clippingBookMark = false
                        this.unClipping = {'color':'gray !important'}
                    } else {
                        this.unClipping = {'color':'gray !important'}
                    }
                }).catch((err) => {
                    
                })
            }
        },
        goBackPreviousPage(){
            let goBackBookMarkMission = localStorage.getItem('bookMarkMission')
            if(goBackBookMarkMission == 'setGoBackBookMarkMission'){
                localStorage.removeItem('bookMarkMission');
                this.$router.push('/bookmarked-mission')
            }else {
                localStorage.removeItem('bookMarkMission');
                let routerLen = this.$route.matched.length
                console.log('moveParentRouter', this.$route.matched, routerLen)
                if (routerLen === 1) {
                    // this.$router.push({
                    //     name: 'Main'
                    // })
                    this.$router.push('/home')
                }else {
                    let query = this.$route.query
                    this.$router.push({
                        name: this.$route.matched[routerLen-2].name,
                        query: query
                    })
                }
            }
        }
    }
}
</script>